import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class CarbonBlack extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M15.816,14.412v3.572L18.909,16.2Zm-2.545,2.729-.6-.349V19.8l2.606-1.5Zm-.032-8.415-.572-.33v3.009l2.606-1.5Zm-.572,3.867V15.6L15.273,14.1ZM12.667,0V3.01l2.606-1.5Zm0,4.2v3.01l2.606-1.5Zm6.785,8.115v3.572L22.544,14.1Zm0-4.2v3.571L22.544,9.9Zm0-4.2V7.488L22.544,5.7Zm-3.636-2.1V5.389L18.909,3.6Zm0,8.4v3.571L18.909,12Zm0-4.2V9.587L18.909,7.8Zm6.909,3.571V6.016L19.633,7.8ZM12.667,20.99V24l2.606-1.5Zm6.423-5.1V12.313L16,14.1Zm-1.2-9.09,1.2.693V3.917L16,5.7Zm1.564,9.717v3.571L22.544,18.3Zm-.362,3.571V16.512L16,18.3Zm3.635-2.1V14.412L19.633,16.2Zm-3.635-6.3V8.115L16,9.9Zm-3.636,2.726-2.787,1.61v.352l2.787,1.61Zm0-4.2-2.787,1.609v.352l2.787,1.61Zm.362,8.4v3.571L18.909,20.4Zm-.362,0L12.667,20.22v.352l2.787,1.61Zm0-13.222V1.818l-2.787,1.61V3.78l1.2.694Zm0,.627-2.787,1.61v.352l2.787,1.609ZM4.91,8.115v3.571L8,9.9ZM3.851,7.5,2.07,6.475l-.795-.459V9.587L4.367,7.8ZM4.91,3.917V7.488L8,5.7Zm-3.635,6.3v3.571L4.367,12Zm0,4.2v3.572L4.367,16.2Zm5.139-1.231-1.5-.868v3.572L8,14.1ZM11.333,19.8v-3.01L8.727,18.3Zm0-16.792V0L8.727,1.505ZM10.2,6.552l1.135.656V4.2L8.727,5.7ZM8.546,17.984l2.787-1.609v-.353l-2.787-1.61Zm0-11.968V9.587l2.787-1.609V7.625L9.64,6.648Zm0-.627L11.333,3.78V3.428L8.546,1.818Zm-4,14.694V16.512L1.456,18.3Zm3.636-6.3V10.214L5.091,12Zm0-8.4V1.818L5.091,3.6Zm0,4.2V6.016L5.091,7.8Zm-3.636,6.3V12.313L1.456,14.1ZM11.333,24V20.99L8.727,22.5ZM8.546,22.182l2.787-1.61V20.22L8.546,18.611Zm-4-10.5V8.115L1.456,9.9Zm0-4.2V3.917L1.456,5.7Zm3.636,10.5V14.412L5.091,16.2Zm-1.767-.6-1.507-.87v3.571L8,18.3Zm1.767,4.8V18.611L5.091,20.4Z" />
      </svg>
    );
  }
}

export default CarbonBlack;
